export const webFonts = [
    "Impact",
    "Arial",
    "Comic Sans MS",
    "Helvetica",
    "Times New Roman",
    "Times",
    "Courier New",
    "Courier",
    "Verdana",
    "Georgia",
    "Palatino",
    "Trebuchet MS",
    "Arial Black",
];
